import { permissionAllowed, Salutation } from "@ews/react-data";
import { useL10n } from "@ews/react-localization-context";
import { IonButton, IonItem } from "@ionic/react";
import React from "react";
import { useDoubleConfirmDialog } from "../../../../Dialog";
import { useMyPermissions } from "../../../../Login/LoginProvider";
import { useInvokeLogoutUser } from "../../../../ReactData/rpc";
import { useUser, useUserPermissions } from "../../../../ReactData/user";
import { getSalutationTranslation } from "../MainSettings";

export const LogoutButton: React.FC<{ id: string, className?: string; }> = ({
    id,
    className
}) =>
{
    const userPermission = useUserPermissions(id);
    const myPermissions = useMyPermissions();
    const user = useUser(id || "");

    const { translate: t } = useL10n();
    const logout = useInvokeLogoutUser();

    const doubleConfirmDialog = useDoubleConfirmDialog();
    const allowedToLogoutUser = permissionAllowed(myPermissions.createUser || 0);

    return <>
        {allowedToLogoutUser ?
            userPermission.allowMultipleLogin === false ? <IonItem>
                <IonButton
                    expand="full"
                    className={`${className || ""}`}
                    onClick={async (e) =>
                    {
                        e.preventDefault();

                        const response = await doubleConfirmDialog({
                            title: t("[REACT_LOGOUT]"),
                            message: t("[REACT_LOGOUT_DIALOG_CONTENT]", { user: `${t(getSalutationTranslation(user.salutation || Salutation.other))} ${user.firstName} ${user.lastName}` }),
                            areYouSureButtonTitle: t("COM_TEMPLATES_ARE_YOU_SURE"),
                            confirmButtonTitle: t("COM_FACPMANAGEMENT_REGRESSION_STATUS_OK"),
                            cancelButtonTitle: t("COM_BANNERS_CANCEL")
                        });

                        if (response) {

                            if (id) {
                                logout({ userId: id });
                            }
                        }
                    }
                    }>{t("[REACT_LOGOUT]")}</IonButton>

            </IonItem> : null
            : null}
    </>;
};
